// AvailabilityBar.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled components for availability visualization
const HourlySegmentsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '12px',
  marginTop: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
}));

const HourSegment = styled(Box)(({ theme, isAvailable, hasBookingInfo }) => ({
  flex: 1,
  height: '100%',
  backgroundColor: isAvailable ? theme.palette.success.light : 
                  hasBookingInfo ? theme.palette.error.light : theme.palette.grey[400],
  margin: '0 1px',
  position: 'relative',
  '&:first-of-type': {
    borderTopLeftRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius,
    marginLeft: 0,
  },
  '&:last-child': {
    borderTopRightRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    marginRight: 0,
  },
}));

const HourLabelsContainer = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  marginTop: '4px',
});

const HourLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.65rem',
  color: theme.palette.text.secondary,
  textAlign: 'center',
}));

// Helper function to group hourly slots by hour
const groupSlotsByHour = (hourlySlots) => {
  const hours = {};
  
  hourlySlots.forEach(slot => {
    const hour = slot.start_time.substring(0, 2);
    if (!hours[hour]) {
      hours[hour] = [];
    }
    hours[hour].push(slot);
  });
  
  return Object.entries(hours).sort((a, b) => a[0].localeCompare(b[0]));
};

const AvailabilityBar = ({ hourlySlots }) => {
  if (!hourlySlots || hourlySlots.length === 0) return null;
  
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
        Today's availability:
      </Typography>
      <HourlySegmentsContainer>
        {hourlySlots.map((slot, index) => (
          <HourSegment
            key={index}
            isAvailable={slot.is_available}
            hasBookingInfo={!slot.is_available && slot.booking_info}
          />
        ))}
      </HourlySegmentsContainer>

      {/* Hour labels */}
      <HourLabelsContainer>
        {groupSlotsByHour(hourlySlots).map(([hour]) => (
          <HourLabel key={hour}>
            {hour}:00
          </HourLabel>
        ))}
      </HourLabelsContainer>
    </Box>
  );
};

export { groupSlotsByHour };
export default AvailabilityBar;